// Farbwahl für Lesezeichen-Ordner: Palette + freie Farbe (<input type=color>) + „keine Farbe".
import { FOLDER_PALETTE } from './keys';

export function FolderColorPicker(props: { value: string | null; onChange: (color: string | null) => void; testId: string }) {
  const { value, onChange, testId } = props;
  return (
    <div className="lfx-bm-colors" role="group" aria-label="Ordnerfarbe" data-testid={testId}>
      <button
        type="button"
        className={`lfx-bm-swatch lfx-bm-swatch--none${value === null ? ' lfx-bm-swatch--active' : ''}`}
        aria-label="Keine Farbe"
        aria-pressed={value === null}
        data-testid={`${testId}-none`}
        onClick={() => onChange(null)}
      />
      {FOLDER_PALETTE.map((c) => (
        <button
          key={c}
          type="button"
          className={`lfx-bm-swatch${value?.toLowerCase() === c ? ' lfx-bm-swatch--active' : ''}`}
          style={{ background: c }}
          aria-label={`Farbe ${c}`}
          aria-pressed={value?.toLowerCase() === c}
          data-testid={`${testId}-${c.slice(1)}`}
          onClick={() => onChange(c)}
        />
      ))}
      <input
        type="color"
        className="lfx-bm-color-input"
        aria-label="Eigene Farbe"
        data-testid={`${testId}-custom`}
        value={value ?? '#ff7a18'}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
